import React from 'react';

const Amount = (props) => {
    const formatAmount = (amount) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }
    return (
        <><strong>{formatAmount(props?.amount)}</strong> {props?.currency}</>
    );
};

export default Amount;
